import React from "react"
import Icon from "../general/Icon"

interface EyeButtonProps {
  className?: string;
  onClick: () => void;
  tabIndex?: number;
}

const EyeButton: React.FC<EyeButtonProps> = (props: EyeButtonProps) => {
  return (
    <button {...props} type="button">
      <Icon symbolId="eye"/>
    </button>
  )
}

export default EyeButton
